import React from 'react';
import PropTypes from 'prop-types';


const MAX_CHARACTER_COUNT = 500;


const SuggestionField = ({ value, onChange }) => (
  <div className="annotator-field">
    <textarea
      dir="auto"
      name="suggestion-text"
      className="suggestion-text"
      placeholder="Write your comment here"
      maxLength={MAX_CHARACTER_COUNT}
      onChange={e => onChange(e.target.value)}
      defaultValue={value}
    />
  </div>
);


SuggestionField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};


SuggestionField.defaultProps = {
  value: '',
};


export default SuggestionField;
